import { ReactElement, useState } from "react";
import {
  useFloating,
  useHover,
  useInteractions,
  flip,
  shift,
  Placement,
  offset,
  autoUpdate,
} from "@floating-ui/react";
import styles from "./Tooltip.module.scss";

type ITooltipProps = {
  children: ReactElement;
  tooltip: ReactElement;
  defaultStyle?: boolean;
  defaultPlacement?: Placement;
};

export default function Tooltip(props: ITooltipProps) {
  const [isOpen, setIsOpen] = useState(false);
  const data = useFloating({
    placement: props.defaultPlacement || "bottom",
    open: isOpen,
    onOpenChange: setIsOpen,
    whileElementsMounted: autoUpdate,
    middleware: [
      offset(5),
      flip({
        crossAxis: !!props.defaultPlacement?.includes("-"),
        fallbackAxisSideDirection: "start",
        // padding: 15,
      }),
      shift({
        // padding: 15
      }),
    ],
  });
  const { context } = data;
  const hover = useHover(context);
  const { getReferenceProps, getFloatingProps } = useInteractions([hover]);
  return (
    <>
      <div ref={context.refs.setReference} {...getReferenceProps()}>
        {props.children}
      </div>
      {isOpen && (
        <div
          ref={context.refs.setFloating}
          style={{
            ...context.floatingStyles,
          }}
          {...getFloatingProps()}
          className={`${styles.tooltipBaseStyle} ${
            props.defaultStyle ? styles.tooltipDefaultStyle : ""
          }`}
        >
          {props.tooltip}
        </div>
      )}
    </>
  );
}
